import React from "react";
export const CommonContext = React.createContext({
  languageData: {},
});

export default CommonContext;
